export default __webpack_public_path__ + "static/media/wi-day-cloudy.d3602df8.svg";